import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { equals } from 'ramda';
import * as styles from './Collection.css';

export interface ICollectionProps {
  href: string;
  title: string;
  label: string;
  imageKey: string;
  className?: string;
  cdnBaseUrl: string;
  color: string | null;
  backgroundColor: string | null;
  onClick(): void;
}

const CollectionComponent: React.FC<ICollectionProps> = props => {
  const { href, title, cdnBaseUrl, imageKey, onClick, className, backgroundColor, color } = props;

  return (
    <div className={className} onClick={onClick}>
      <a href={href} target="_blank" {...mergeStyles(styles['link'], { backgroundColor })}>
        <span {...mergeStyles(styles['title'], { color })}>{title}</span>
        <img
          className={styles['image']}
          src={`${cdnBaseUrl}${imageKey}.png`}
          srcSet={`${cdnBaseUrl}${imageKey}@2x.png 2x, ${cdnBaseUrl}${imageKey}@3x.png 3x`}
        />
      </a>
    </div>
  );
};

export const Collection = React.memo(CollectionComponent, arePropsEqual);

export function arePropsEqual(prevProps: ICollectionProps, nextProps: ICollectionProps) {
  const { onClick: _, ...prevPropsWithoutOnClick } = prevProps;
  const { onClick: __, ...nextPropsWithoutOnClick } = nextProps;

  return equals(prevPropsWithoutOnClick, nextPropsWithoutOnClick);
}
